import type { Person } from '../../../eventsApi/persons/person'
import type { Service } from '../../services/service'

export class ProductMovement {
    productMovementId: string
    userId: string
    companyId: string
    personId?: string
    createdAt: Date
    updatedAt: Date
    movedAt: Date
    expiresAt?: Date
    quantity: number
    value: number
    batchNumber?: string
    supplier?: string
    brand?: string
    type: string
    notes?: string
    serviceId?: string
    invoiceId?: string
    status: number
    service: Service
    person?: Person
    appointmentId?: string
    loggedUserId?: string
    reason?: string
}
